//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey, deepClone } from '@/tools'
import { RadioTitle, RadioItem } from './setting'
import draggable from 'vuedraggable'

export default {
  props: {
    question: {
      type: Object,
      default: () => {
        return {
          v_ownId: setOwnKey(),
          v_active: false,
          v_label: '单选题',
          type: 'radio',
          displayIndex: true,
          title: '请选择一个选项',
          required: true,
          voteVisible: false,
          column: 1,
          uploadArrow: true,
          uploadArrowRequired: false,
          logic: {
            blocks: {
              typeBlock: 'all',
              list: [],
            },
          },
          options: [],
        }
      },
    },
  },
  components: {
    RadioTitle,
    RadioItem,
    draggable,
  },
  data() {
    return {
      editorOption: {
        modules: { toolbar: [] },
        placeholder: '请输入',
      },
      curItem: null,
      type: null,
      curQuestion: {},
    }
  },
  computed: {
    editor() {
      return this.$refs['radio-title'].quill
    },
  },
  mounted() {
    let editor = this.editor
    if (editor) {
      this.$nextTick(() => {
        let len = editor.getLength()
        editor.setSelection(len)
      })
    }
  },
  watch: {
    question: {
      handler(newV) {
        this.curQuestion = deepClone(newV)
      },
      immediate: true,
    },
  },
  methods: {
    itemHandler(item, index) {
      this.curItem = item
      this.type = 'item'
    },
    headerHandler() {
      this.curItem = null
      this.type = 'title'
    },
    onEditorChange(event, len) {
      event.quill.deleteText(len, 4)
    },
    //开始拖拽事件
    onStart() {
      this.drag = true
      // 振动2秒
      if (navigator.vibrate) {
        navigator.vibrate(500)
      } else if (navigator.webkitVibrate) {
        navigator.webkitVibrate(500)
      }
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false
    },
    removeItem(item, index) {
      if (this.curQuestion.options.length == 2) {
        new this.$Toast({
          text: '至少保留2个选项',
          time: 1500,
          position: 'top',
          distance: '50%',
        })
        return
      }
      this.curQuestion.options.splice(index, 1)
      this.question.options = deepClone(this.curQuestion.options)
      this.type = null
    },
    addQuestion() {
      let newItem = {
        v_ownId: setOwnKey(),
        v_editable: false,
        text: `选项${this.question.options.length + 1}`,
        score: 0,
        blankVisible: false,
        blankRule: 'ignore',
        blankMaxLengthVisible: false,
        blankMinLength: null,
        blankMaxLength: null,
        blankRequired: false,
      }
      this.question.options.push(newItem)
      this.curQuestion = deepClone(this.question)
    },
    getValue() {
      return this.curQuestion
    },
    // 标题栏失焦
    blurInput({ type, index }) {
      if (type == 'title') {
        if (!this.curQuestion.title) {
          this.curQuestion.title = this.question.title
        } else {
          this.question.title = this.curQuestion.title
        }
      } else {
        let cItem = this.question.options[index]
        let item = this.curQuestion.options[index]
        if (!item.text) {
          this.curQuestion.options[index]['text'] = cItem.text
        } else {
          this.question.options = deepClone(this.curQuestion.options)
        }
      }
    },
  },
}
